import { render, staticRenderFns } from "./SiteMenu.vue?vue&type=template&id=bf4b6c06&scoped=true&"
import script from "./SiteMenu.vue?vue&type=script&lang=js&"
export * from "./SiteMenu.vue?vue&type=script&lang=js&"
import style0 from "./SiteMenu.vue?vue&type=style&index=0&id=bf4b6c06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4b6c06",
  null
  
)

export default component.exports